
const $ = jQuery.noConflict()

var self = module.exports = {
  props: {
    ps: null,
    container: null,
    windowSize : $(window).width()
  },
  init: function(trigger) {
    $(trigger).each(function( index ) {
   
      var id = $(this).attr('id');
      self.service.activateScrollbar('#'+id);
      self.events.windowResize('#'+id);
    })
  },

  events: {
    //Destroys scrollbar if it is a mobile only version.
    windowResize: function(target) {
      $(window).on('resize', function() {
        self.props.windowSize = $(window).width()

        if(self.props.windowSize >= 1024) {
          if ($(target).hasClass("side-scroll--mobile") ) {
            self.props.ps.destroy();
            self.props.ps = null;
          }
        } else {
          if ($(target).hasClass("side-scroll--mobile") && !$(target).hasClass("ps") ) {
            self.props.ps = new PerfectScrollbar(self.props.container);
          }
        }
      })
    }
  },

  service: {
    //Activates scrollbar if it exists.
    activateScrollbar: function(target) {
      self.props.container = document.querySelector(target);

      if ($(target).length > 0) { 
        self.props.ps = new PerfectScrollbar(self.props.container);
      }
    }
  }
}




